import { AxiosRequestConfig, default as axios } from 'axios';

import { getApiUrl } from '@/env.ts';

export const axiosInstance = axios.create({
    withCredentials: true,
    baseURL: getApiUrl(),
});

export const axiosApi = {
    get: <T>(url: string, config?: AxiosRequestConfig) => axiosInstance.get<T>(url, config),
    post: <T>(url: string, data?: unknown, config?: AxiosRequestConfig) =>
        axiosInstance.post<T>(url, data, config),
    patch: <T>(url: string, data?: unknown, config?: AxiosRequestConfig) =>
        axiosInstance.patch<T>(url, data, config),
    delete: <T>(url: string, config?: AxiosRequestConfig) => axiosInstance.delete<T>(url, config),
};
